"use client";

import Link from "next/link";

import { CostSummary } from "@/components/costs/cost-summary";
import { useShell } from "@/components/shell/shell-context";
import { formatCount } from "@/lib/format";

/** Übersicht: Kosten des Monats und Stand der Datenquellen. Weitere Kennzahlen und Erfolgsmessung folgen. */
export function Overview() {
  const { project, connections } = useShell();
  const connected = connections?.filter((c) => c.status === "connected").length ?? 0;

  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-4 px-6 py-8 sm:px-9">
      <div className="text-[13px] text-muted">Projekt {project?.domain}</div>
      <h1 className="text-3xl font-semibold tracking-tight">Übersicht</h1>
      <p className="text-sm leading-relaxed text-muted">
        Hier entstehen später weitere Kennzahlen und die Erfolgsmessung. Die Module öffnest du über die Navigation.
      </p>
      {project && <CostSummary key={project.id} projectId={project.id} />}
      {connections && (
        <p className="text-sm">
          {formatCount(connected)} von {formatCount(connections.length)} Datenquellen verbunden.{" "}
          <Link href="/settings/connections" className="text-accent underline">
            Verbindungen verwalten
          </Link>
        </p>
      )}
    </div>
  );
}
